export const userProfileLink = (userId: string) => `/profile/${userId}`